import { VariantStatus } from '../../manage/utils/variantUtils'

import IconsBase from './IconsBase'

type Props = {
  statusFilter: VariantStatus
  hasLoadingVariants?: boolean
}

const CollapsedIcons = (props: Props) => (
  <IconsBase {...props} tooltipPlacement="left" />
)

export default CollapsedIcons
